<template>
  <section>
    <div class="header settlement">
      <p>SETTLEMENT</p>
      <div>
        <div @click="handleRedirect">
          <svg
            width="19"
            height="16"
            viewBox="0 0 19 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 7L4.92969 7L9.5 2.42969L8 0.929687L0.929687 8L8 15.0703L9.5 13.5703L4.92969 9L19 9L19 7Z"
              fill="#655D79"
            />
          </svg>
        </div>
        <p>Unsettled Transactions</p>
      </div>
    </div>
    <data-table
        :contents="contents.settlementTransactions"
        :loading="contents.loading"
        :page-info="contents.page_info"
        :columns="columns"
        :handle-cell-click="goToSettlement"
        :handleCheckboxSelected="onRowChecked"
        :useCheckbox="true"
        :show-export="state.showExport"
        :handle-export-download="handleExportDownload"
        :title="state.title"
        primaryButtonName="Schedule For Processing"
        :handlePrimaryButtonClick="handlePrimaryButtonClick"
        :handlePrimaryButtonDisabled="!rowSelected.length"
        :showFilter="state.showFilter"
        :showFilterSlot="state.showFilter"
        :on-page-change="state.onPageChange"
        :clear-filter="clearFilter"
        :paramsObject="{ type: 'retries' }"
    >
      <template v-slot:default="slotProps">
        <div class="filter" v-if="slotProps.openFilters">
          <Input
              label="Reference"
              :value="state.filter.settlement_reference"
              :onChange="(value) => (state.filter.settlement_reference = value)"
          />
          <Input
              label="Source Account"
              :value="state.filter.collection_nuban"
              :onChange="(value) => (state.filter.collection_nuban = value)"
          />
          <Input
              label="Destination Account"
              :value="state.filter.settlement_nuban"
              :onChange="(value) => (state.filter.settlement_nuban = value)"
          />
          <Input
              label="Merchant"
              :value="state.filter.merchant_name"
              :onChange="(value) => (state.filter.merchant_name = value)"
          />
          <Input
              label="Amount"
              :value="state.filter.amount"
              :onChange="(value) => (state.filter.amount = value)"
          />
          <Datepicker
              label="Initiation Date"
              :value="state.filter.settlement_date"
              :onDateSelected="
              (value) =>
                (state.filter.settlement_date = `${moment(value).format(
                  'YYYY-MM-DD'
                )}`)
            "
          />
          <Button
              buttonName="Apply Filter"
              :onClick="handleApplyFilter"
              classes="primary"
          />
        </div>
      </template>
      <template v-slot:noContent>
        <h1>No Transaction</h1>
        <p>All transaction will show here</p>
      </template>
    </data-table>
<!--    <Table-->
<!--      :handleExportDownload="handleExportDownload"-->
<!--      :contents="contents.settlementTransactions"-->
<!--      :title="state.title"-->
<!--      :showFliter="state.showFilter"-->
<!--      :showExport="state.showExport"-->
<!--      :pageInfo="contents.page_info"-->
<!--      :onPageChange="state.onPageChange"-->
<!--      primaryButtonName="Schedule For Processing"-->
<!--      :handlePrimaryButtonClick="handlePrimaryButtonClick"-->
<!--      :handlePrimaryButtonDisabled="!rowSelected.length"-->
<!--      singleDetailRouteName="unsettled-list-details"-->
<!--      :clearFilter="clearFilter"-->
<!--      :onRowChecked="onRowChecked"-->
<!--      :rowSelected="rowSelected"-->
<!--      :checkboxAll="checkboxAll"-->
<!--      :checkboxNone="checkboxNone"-->
<!--      routerClickEvent="dblclick"-->
<!--      :loading="contents.loading"-->
<!--    >-->
<!--      <template v-slot:default="slotProps">-->
<!--        <div class="filter" v-if="slotProps.openFilters">-->
<!--          <Input-->
<!--            label="Reference"-->
<!--            :value="state.filter.transaction_reference"-->
<!--            :onChange="(value) => (state.filter.transaction_reference = value)"-->
<!--          />-->
<!--          <Input-->
<!--            label="Merchant ID"-->
<!--            :value="state.filter.merchantId"-->
<!--            :onChange="(value) => (state.filter.merchantId = value)"-->
<!--          />-->
<!--          <Datepicker-->
<!--            label="Payment Date"-->
<!--            :value="state.filter.from"-->
<!--            :onDateSelected="-->
<!--              (value) => (state.filter.from = new Date(value).toString())-->
<!--            "-->
<!--            :disabledDates="state.disabledDatesFrom"-->
<!--            placeholder="From"-->
<!--          />-->
<!--          <Datepicker-->
<!--            hideLabel-->
<!--            :value="state.filter.to"-->
<!--            :onDateSelected="-->
<!--              (value) => (state.filter.to = new Date(value).toString())-->
<!--            "-->
<!--            :disabledDates="state.disabledDatesTo"-->
<!--            placeholder="To"-->
<!--          />-->
<!--          <Button-->
<!--            buttonName="Apply Fliter"-->
<!--            :onClick="handleApplyFliter"-->
<!--            classes="primary"-->
<!--          />-->
<!--        </div>-->
<!--      </template>-->
<!--      <template v-slot:nocontent>-->
<!--        <h1>No Transaction</h1>-->
<!--        <p>All transaction will show here</p>-->
<!--      </template>-->
<!--    </Table>-->
  </section>
</template>
<script>
import {
  reactive,
  onBeforeMount,
  computed,
  onMounted,
  watch,
} from "@vue/composition-api";
// import Table from "@/components/table.vue";
import Checkbox from "@/components/checkbox.vue";
import NoContent from "@/components/noContent.vue";
import Input from "@/components/input.vue";
import DropdownOptions from "@/components/dropdownoptions.vue";
import Datepicker from "@/components/datepicker.vue";
import Select from "@/components/select.vue";
import Loader from "@/components/loader.vue";
import Button from "@/components/button.vue";
import { csvExport, pdfExport } from "@/lib/download";
import dataTable from "@/components/dataTable";

export default {
  setup(props, { root }) {
    const store = root.$store;
    const columns = [
      { label: "REFERENCE", field: "REFERENCE" },
      { label: "MERCHANT ID", field: "MERCHANT ID" },
      { label: "MERCHANT NAME", field: "MERCHANT NAME" },
      { label: "PAYMENT DATE", field: "PAYMENT DATE", sortable: false },
      { label: "PAYER NAME", field: "PAYER NAME" },
      {
        label: "PAYER ACCOUNT",
        field: "PAYER ACCOUNT",
        splitBy: "-",
        sortable: false
      },
      { label: "AMOUNT", field: "AMOUNT", sortable: false }
    ];
    const state = reactive({
      title: "",
      showFilter: true,
      showExport: true,
      scheduleProcessing: [],
      onPageChange: () => {},
      filter: {
        to: "",
        from: "",
      },
      appliedFilter: {},
      showDropdown: true,
      dropdowns: [],
      disabledDatesFrom: {
        from: new Date(),
      },
      disabledDatesTo: {
        from: new Date(),
      },
    });

    onBeforeMount(() => {
      store.dispatch("getSettlementTransactions", state.filter);
    });

    const contents = computed(() => store.getters.getSettlementTransactions);
    const rowSelected = computed(() => store.getters.getRowSelected);
    const bankNames = computed(() => store.getters.getBankNames);

    const setBanks = () => {
      const banks = Object.values(bankNames.value).map(({ code, name }) => ({
        name,
        value: code,
      }));

      banks.unshift({ name: "Select bank", value: "" });

      state.dropdowns = banks;
    };

    onMounted(() => {
      setBanks();
    });

    watch(
      () => store.getters.getSettlementTransactions,
      (value) => {
        if (value.page_info) {
          state.title = `${value.page_info.total} Transactions`;
        }
      }
    );

    watch(
      () => root.$route.query,
      () => {
        store.dispatch("getSettlementTransactions", { ...root.$route.query });
      }
    );

    watch(
      () => state.filter.from,
      (value) => {
        state.disabledDatesTo.from = new Date();
      }
    );

    watch(
      () => state.filter.to,
      (value) => {
        state.disabledDatesFrom.from = new Date(value);
      }
    );

    const handleRedirect = () =>
      root.$options.router.push("/dashboard/settlements/processed");

    const handleApplyFilter = () => {
      state.appliedFilter = state.filter;

      store.dispatch("getSettlementTransactions", state.filter);
    };

    const fullContents = computed(
      () => store.getters.getFullSettlementTransactions
    );

    const handleExportDownload = (type) => {
      store.dispatch("download", {
        downloadType: type,
        filter: { ...state.appliedFilter, download: "true" },
        url: "dashboard/admin/settlements/transactions/unsettled",
        key: "unsetlled_transactions",
      });
    };

    const clearFilter = () => {
      state.appliedFilter = {};
      state.filter = {
        unique_reference: " ",
        source_nuban: " ",
        destination_nuban: " ",
        merchant_id: " ",
        net_amount: " ",
        transaction_time: " ",
      };

      store.dispatch("getSettlementTransactions", {});
    };

    const onRowChecked = (e) => {
      let row_selected = [];

      if (e.selectedRows.length > 0) {
        for (let selected_row of e.selectedRows) {
          row_selected.push(selected_row.id);
        }
      }

      store.commit("setUnsettledTransactionsRowSelected", row_selected);
    };

    const handlePrimaryButtonClick = () => {
      store
        .dispatch("settlementProcessing", { rows: rowSelected.value })
        .then((result) => {
          // console.log(result, "<== Settlement Schedule Result");
          root.$options.router.replace("/dashboard/settlements/pending");
        })
        .catch(() => {});
    };

    const checkboxAll = () =>
      store.dispatch("selectAllUnsettledSettlementTransactions", state.filter);

    const checkboxNone = () => store.commit("setRowSelected", { type: "none" });

    const onSelected = ({ target }) => {
      state.filter.payer_bank_code = target.value;
    };

    const goToSettlement = (e) => {
      root.$options.router.push({
        name: "unsettled-list-details",
        params: { id: e.row.id },
      });
    }

    return {
      columns,
      state,
      handleRedirect,
      contents,
      handleApplyFilter,
      clearFilter,
      handleExportDownload,
      onRowChecked,
      handlePrimaryButtonClick,
      rowSelected,
      checkboxAll,
      checkboxNone,
      onSelected,
      goToSettlement
    };
  },
  components: {
    // Table,
    dataTable,
    Checkbox,
    Input,
    Datepicker,
    Button,
    Loader,
    NoContent,
    DropdownOptions,
    Select,
  },
};
</script>
<style lang="scss" scoped>
.settlement {
  padding: 30px 0 30px 20px;
  > p {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.1em;
    color: rgba(101, 93, 121, 0.7);
  }

  > div {
    display: flex;
    margin-top: 30px;

    svg {
      cursor: pointer;
    }

    p {
      margin-left: 16px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 19px;
      color: #261940;
    }
  }
}

.margin {
  margin: 0 30px;
}

.filter {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 0 24px;

  .button-comp {
    margin-left: 20px;
    margin-bottom: 30px;
  }
}
</style>